import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ['bars', 'close'];

    connect() {
        this.isOpen = false;
        this.ariaLabel = this.element.getAttribute('aria-label');
        this.altLabel = this.element.dataset.altLabel;
        document.addEventListener('mobile-nav-toggle:changed', this.updateState.bind(this));
        document.addEventListener('mobile-nav:closed', this.updateState.bind(this));
    }

    disconnect() {
        document.removeEventListener('mobile-nav-toggle:changed', this.updateState.bind(this));
        document.removeEventListener('mobile-nav:closed', this.updateState.bind(this));
    }

    toggle() {
        this.isOpen = !this.isOpen;

        this.dispatch('changed', {
            detail: {
                isOpen: this.isOpen,
                button: this.element,
            },
            bubbles: true,
        });
    }

    updateState({ detail: { isOpen } }) {
        this.isOpen = isOpen;
        this.element.setAttribute('aria-expanded', isOpen);
        this.element.setAttribute('aria-label', isOpen ? this.altLabel : this.ariaLabel);
        this.barsTarget.classList.toggle('hidden', isOpen);
        this.closeTarget.classList.toggle('hidden', !isOpen);
    }
}
